export default __webpack_public_path__ + "abcaa5a1fc11da1fec5d1e5398c40b0f.png";